/**
 * Café de Spécialité — révèle la carte et anime le chiffre (0 → note) à l'entrée
 * dans le viewport. Respecte prefers-reduced-motion (valeur finale immédiate).
 */
(function () {
  'use strict';

  var cards = document.querySelectorAll('.specialite-cafe__card');
  if (!cards.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateCount(el) {
    var target = parseInt(el.getAttribute('data-target') || '0', 10);
    if (!target) {
      el.textContent = '0';
      return;
    }
    if (reduce) {
      el.textContent = String(target);
      return;
    }
    var duration = 1200;
    var startTs = null;
    function step(ts) {
      if (startTs === null) startTs = ts;
      var p = Math.min((ts - startTs) / duration, 1);
      el.textContent = String(Math.round(easeOutCubic(p) * target));
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = String(target);
      }
    }
    requestAnimationFrame(step);
  }

  function reveal(card) {
    card.classList.add('is-revealed');
    var count = card.querySelector('.specialite-cafe__count');
    if (count) animateCount(count);
  }

  // Pas d'IntersectionObserver → on révèle tout de suite (fallback sûr).
  if (!('IntersectionObserver' in window)) {
    cards.forEach(reveal);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.3 }
  );

  cards.forEach(function (card) {
    observer.observe(card);
  });
})();
